<template>
    <div class="arrow-card__circle">
        <p>{{ step }}</p>
    </div>
</template>

<script>
export default {
    name: 'CardScheduleInstallationCircle.vue',

    props: {
        step: {
            type: Number,
            default: -1,
        },

        circleColor: {
            type: String,
            default: 'secondary',
        }
    },

    computed: {
    
    }
}
</script>
  
<style>
.arrow-card__circle {
    position: absolute;
    content: "";
    height: 54px;
    width: 54px;
    top: 50%;
    transform: translate(-90%, -50%);
    background: white; 
    border-radius: 100% !important; 
    border: 0.50px var(--v-primary-base) solid;
    box-shadow: 0px 0px 0px 10px #F2F1FF, 0px 0px 0px 10.5px var(--v-primary-base);
}

.arrow-card__circle p {
    position: absolute;
    top: 50%;
    left: 30%;
    transform: translateY(-50%);
    font-size:40px;
    color: var(--v-primary-base);
    font-weight: 900;
}


@media screen and (min-width: 1264px) {
    .arrow-card__circle {

        width: 64px;
        height: 64px;
    }
}

@media screen and (max-width: 600px) {
    .arrow-card__circle {
        position: relative;
        left: 50%;
    }
}
</style>